import { render } from "./AllMedicationTypes.vue?vue&type=template&id=55d55710&scoped=true"
import script from "./AllMedicationTypes.vue?vue&type=script&lang=js"
export * from "./AllMedicationTypes.vue?vue&type=script&lang=js"

import "./AllMedicationTypes.vue?vue&type=style&index=0&id=55d55710&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55d55710"]])

export default __exports__